let permission: any = {
    // systemSetup: {
    //     label: "系统管理模块", data: [
    //         {
    //             prop: 'system', label: "系统信息", status: false, show: true, data: [
    //                 // {
    //                 //     prop: 'mandate',
    //                 //     label: "授权信息",
    //                 //     status: false,
    //                 //     url: ['/system/authorization/getECloudAuthInfo', '/system/authorization/replaceECloudAuth'],
    //                 //     oam: false
    //                 // },
    //                 {
    //                     prop: 'version', label: "版本信息", status: false, data: [
    //                         {
    //                             prop: 'query',
    //                             label: "查看",
    //                             status: false,
    //                             url: ['/system/version/getVersionInfo', '/system/version/queryHistoryList'],
    //                             oam: false,
    //                         },
    //                         {
    //                             prop: 'update',
    //                             label: "更新",
    //                             status: false,
    //                             url: ['/system/version/upgrade'],
    //                             oam: false
    //                         },
    //                         {
    //                             prop: 'upload',
    //                             label: "上传",
    //                             status: false,
    //                             url: ['/system/version/upgrade', '/system/version/beforeUploadUpdatePacket'],
    //                             oam: false
    //                         },
    //                     ]
    //                 },
    //                 // {
    //                 //     prop: 'systemSet', label: "系统设置", status: false, data: [
    //                 //         {
    //                 //             prop: 'module',
    //                 //             label: "计价模块设置",
    //                 //             status: false,
    //                 //             url: ['/system/config/getModuleEnable', '/user/agentConfig/setBillingSwitch'],
    //                 //             oam: false
    //                 //         },
    //                 //         {
    //                 //             prop: 'pricing',
    //                 //             label: "产品定价设置",
    //                 //             status: false,
    //                 //             url: ['/system/config/getProductDiscount', '/system/config/setProductDiscount'],
    //                 //             oam: false
    //                 //         },
    //                 //     ]
    //                 // },
    //             ]
    //         },
    //         {
    //             prop: 'permission', label: "权限管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'user', label: "客户管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/user/query',], oam: false},
    //                         {prop: 'create', label: "创建用户", status: false, url: ['/user/backendAddUser',], oam: false},
    //                         {prop: 'login', label: "账号登录", status: false, url: [], oam: false},
    //                         {prop: 'freeze', label: "冻结账号", status: false, url: ['/user/updateUserFreeze'], oam: false},
    //                         {
    //                             prop: 'unfreeze',
    //                             label: "解冻账号",
    //                             status: false,
    //                             url: ['/user/updateUserFreeze'],
    //                             oam: false
    //                         },
    //                         {prop: 'logout', label: "注销账号", status: false, url: ['/user/updateUserCancel'], oam: false},
    //                         // {
    //                         //     prop: 'changeEmail',
    //                         //     label: "更换邮箱账号",
    //                         //     status: false,
    //                         //     url: ['/user/updateUserEmail'],
    //                         //     oam: false
    //                         // },
    //                         {prop: 'accountInfo', label: "账号信息", status: false, url: ['/user/updateUser'], oam: false},
    //                         {
    //                             prop: 'resetPassword',
    //                             label: "修改密码",
    //                             status: false,
    //                             url: ['/user/resetPassword'],
    //                             oam: false
    //                         },
    //                         // {
    //                         //     prop: 'activationEmail',
    //                         //     label: "激活邮箱",
    //                         //     status: false,
    //                         //     url: ['/user/updateUserActivateEmail'],
    //                         //     oam: false
    //                         // },
    //                         // {
    //                         //     prop: 'changeAdmin',
    //                         //     label: "转为后台用户",
    //                         //     status: false,
    //                         //     url: ['/user/privilege/queryRoleByMultipleParam', '/user/department/query', '/user/privilege/setUserRole'],
    //                         //     oam: false
    //                         // },
    //                         // {
    //                         //     prop: 'setPermission',
    //                         //     label: "设置角色",
    //                         //     status: false,
    //                         //     url: ['/user/privilege/queryRoleByMultipleParam', '/user/privilege/setUserRole'],
    //                         //     oam: false
    //                         // },
    //                         // {
    //                         //     prop: 'setDepartment',
    //                         //     label: "设置部门",
    //                         //     status: false,
    //                         //     url: ['/user/department/query', '/user/department/batchAttachDepartment'],
    //                         //     oam: false
    //                         // },
    //                         {prop: 'recharge', label: "现金充值", status: false, url: ['/user/bill/backendAddCashMoney'], oam: false},
    //                         {prop: 'addVoucher', label: "添加代金券", status: false, url: ['/user/bill/backendAddCouponMoney'], oam: false},
    //                         {prop: 'recycleVoucher', label: "回收代金券", status: false, url: ['/user/bill/backendAddRefundCouponMoney'], oam: false},
    //                     ]
    //                 },
    //                 {
    //                     prop: 'role', label: "角色管理", status: false, data: [
    //                         {
    //                             prop: 'create',
    //                             label: "添加角色",
    //                             status: false,
    //                             url: ['/user/privilege/addRole'],
    //                             oam: false
    //                         },
    //                         {
    //                             prop: 'list',
    //                             label: "列表",
    //                             status: false,
    //                             url: ['/user/privilege/queryRoleByMultipleParam'],
    //                             oam: false
    //                         },
    //                         {
    //                             prop: 'destroy',
    //                             label: "删除",
    //                             status: false,
    //                             url: ['/user/privilege/deleteRole'],
    //                             oam: false
    //                         },
    //                         {
    //                             prop: 'modify',
    //                             label: "修改",
    //                             status: false,
    //                             url: ['/user/privilege/getRoleInfoByID', '/user/privilege/updateRole'],
    //                             oam: false
    //                         },
    //                         // {
    //                         //     prop: 'set',
    //                         //     label: "设置角色权限",
    //                         //     status: false,
    //                         //     url: ['/user/privilege/setRoleDataAuthority'],
    //                         //     oam: false
    //                         // },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'childAccount', label: '子账号管理', status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/user/query'], oam: false},
    //                         // {prop: 'create', label: "添加用户", status: false, url: ['/user/backendAddUser'], oam: false},
    //                         {prop: 'setRole', label: "设置角色", status: false, url: ['/user/privilege/setUserRole'], oam: false},

    //                     ]
    //                 },
    //                 // {
    //                 //     prop: 'department', label: "部门管理", status: false, data: [
    //                 //         {prop: 'list', label: "列表", status: false, url: ['/user/department/query'], oam: false},
    //                 //         {prop: 'create', label: "新建部门", status: false, url: ['/user/department/add'], oam: false},
    //                 //         {
    //                 //             prop: 'modify',
    //                 //             label: "修改部门",
    //                 //             status: false,
    //                 //             url: ['/user/department/update'],
    //                 //             oam: false
    //                 //         },
    //                 //         {
    //                 //             prop: 'destory',
    //                 //             label: "删除部门",
    //                 //             status: false,
    //                 //             url: ['/user/department/delete'],
    //                 //             oam: false
    //                 //         },
    //                 //         {
    //                 //             prop: 'modifyMember',
    //                 //             label: "移出/增加部门成员",
    //                 //             status: false,
    //                 //             url: ['/user/department/query', '/user/query', '/user/department/batchAttachDepartment'],
    //                 //             oam: false
    //                 //         },
    //                 //     ]
    //                 // },
    //             ]
    //         },
    //     ]
    // },
    operationsManagement: {
        label: "业务管理模块", data: [
            {
                prop: "overview", label: "总览", status: true, show: true, disabled: true, data: [
                    {
                        prop: "overview",
                        label: "运营总览",
                        status: true,
                        url: ['/user/queryCustomerInfo', '/statistic/overView/queryUserOverView', '/statistic/overView/queryResourceOverView'],
                        oam: false,
                        disabled: true,
                    },
                    // {
                    //     prop: "userOverview",
                    //     label: "个人总览",
                    //     status: false,
                    //     url: ['/user/getUserResourceRenewal', '/user/getUserResourceSummary', '/user/getUserMonthBillSummary', '/user/queryCustomerInfo', '/user/getUserBalance', '/user/bulletin/query', '/user/getUserCurrentConsume'],
                    //     oam: false
                    // },
                ]
            },
            // {
            //     prop: "failureNotice", label: "故障通知", status: false, show: true, data: [
            //         {prop: "failureNotice", label: "故障通知", status: false, url: [], oam: false},
            //     ]
            // },
            {
                prop: 'permission', label: "客户管理", status: false, show: true, data: [
                    {
                        prop: 'user', label: "客户管理", status: false, data: [
                            {prop: 'list', label: "列表", status: false, url: ['/user/query',], oam: false},
                            {prop: 'create', label: "创建用户", status: false, url: ['/user/backendAddUser',], oam: false},
                            {prop: 'login', label: "账号登录", status: false, url: ['/user/getFEToken'], oam: false},
                            {prop: 'freeze', label: "冻结账号", status: false, url: ['/user/updateUserFreeze'], oam: false},
                            {
                                prop: 'unfreeze',
                                label: "解冻账号",
                                status: false,
                                url: ['/user/updateUserFreeze'],
                                oam: false
                            },
                            {prop: 'logout', label: "注销账号", status: false, url: ['/user/updateUserCancel'], oam: false},
                            // {
                            //     prop: 'changeEmail',
                            //     label: "更换邮箱账号",
                            //     status: false,
                            //     url: ['/user/updateUserEmail'],
                            //     oam: false
                            // },
                            {prop: 'accountInfo', label: "账号信息", status: false, url: ['/user/updateUser'], oam: false},
                            {
                                prop: 'resetPassword',
                                label: "修改密码",
                                status: false,
                                url: ['/user/resetPassword'],
                                oam: false
                            },
                            // {
                            //     prop: 'activationEmail',
                            //     label: "激活邮箱",
                            //     status: false,
                            //     url: ['/user/updateUserActivateEmail'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'changeAdmin',
                            //     label: "转为后台用户",
                            //     status: false,
                            //     url: ['/user/privilege/queryRoleByMultipleParam', '/user/department/query', '/user/privilege/setUserRole'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'setPermission',
                            //     label: "设置角色",
                            //     status: false,
                            //     url: ['/user/privilege/queryRoleByMultipleParam', '/user/privilege/setUserRole'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'setDepartment',
                            //     label: "设置部门",
                            //     status: false,
                            //     url: ['/user/department/query', '/user/department/batchAttachDepartment'],
                            //     oam: false
                            // },
                            {prop: 'recharge', label: "现金充值", status: false, url: ['/user/bill/backendAddCashMoney'], oam: false},
                            {prop: 'recycleCashMoney', label: "现金回收", status: false, url: ['/user/bill/backendAddRefundCashMoney'], oam: false},
                            {prop: 'addVoucher', label: "添加代金券", status: false, url: ['/user/bill/backendAddCouponMoney'], oam: false},
                            {prop: 'recycleVoucher', label: "回收代金券", status: false, url: ['/user/bill/backendAddRefundCouponMoney'], oam: false},
                        ]
                    },
                    {
                        prop: "discount", label: "折扣管理", status: false, data: [
                            {
                                prop: "list",
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/discount/queryUserDiscount'],
                                oam: false
                            },
                            {
                                prop: "create",
                                label: "新建折扣",
                                status: false,
                                url: ['/user/query', '/user/discount/initDiscount'],
                                oam: false
                            },
                            {
                                prop: "add",
                                label: "添加折扣",
                                status: false,
                                url: ['/user/discount/initDiscount'],
                                oam: false
                            },
                            {
                                prop: "modify",
                                label: "修改折扣",
                                status: false,
                                url: ['/user/discount/updateDiscount'],
                                oam: false
                            },
                            {
                                prop: "delete",
                                label: "删除折扣",
                                status: false,
                                url: ['/user/discount/deleteDiscount'],
                                oam: false
                            },
                        ]
                    },
                    // {
                    //     prop: 'role', label: "角色管理", status: false, data: [
                    //         {
                    //             prop: 'create',
                    //             label: "添加角色",
                    //             status: false,
                    //             url: ['/user/privilege/addRole'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'list',
                    //             label: "列表",
                    //             status: false,
                    //             url: ['/user/privilege/queryRoleByMultipleParam'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'destroy',
                    //             label: "删除",
                    //             status: false,
                    //             url: ['/user/privilege/deleteRole'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'modify',
                    //             label: "修改",
                    //             status: false,
                    //             url: ['/user/privilege/getRoleInfoByID', '/user/privilege/updateRole'],
                    //             oam: false
                    //         },
                    //         // {
                    //         //     prop: 'set',
                    //         //     label: "设置角色权限",
                    //         //     status: false,
                    //         //     url: ['/user/privilege/setRoleDataAuthority'],
                    //         //     oam: false
                    //         // },
                    //     ]
                    // },
                    // {
                    //     prop: 'childAccount', label: '子账号管理', status: false, data: [
                    //         {prop: 'list', label: "列表", status: false, url: ['/user/query'], oam: false},
                    //         // {prop: 'create', label: "添加用户", status: false, url: ['/user/backendAddUser'], oam: false},
                    //         {prop: 'setRole', label: "设置角色", status: false, url: ['/user/privilege/setUserRole'], oam: false},

                    //     ]
                    // },
                    // {
                    //     prop: 'department', label: "部门管理", status: false, data: [
                    //         {prop: 'list', label: "列表", status: false, url: ['/user/department/query'], oam: false},
                    //         {prop: 'create', label: "新建部门", status: false, url: ['/user/department/add'], oam: false},
                    //         {
                    //             prop: 'modify',
                    //             label: "修改部门",
                    //             status: false,
                    //             url: ['/user/department/update'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'destory',
                    //             label: "删除部门",
                    //             status: false,
                    //             url: ['/user/department/delete'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'modifyMember',
                    //             label: "移出/增加部门成员",
                    //             status: false,
                    //             url: ['/user/department/query', '/user/query', '/user/department/batchAttachDepartment'],
                    //             oam: false
                    //         },
                    //     ]
                    // },
                ]
            },
            {
                prop: 'finance', label: "财务管理", status: false, show: true, data: [
                    {
                        prop: 'cash', label: "现金管理", status: false, data: [
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/bill/queryCashBillList'],
                                oam: false
                            },
                            {
                                prop: 'recharge',
                                label: "现金充值",
                                status: false,
                                url: ['/user/query', '/user/bill/backendAddCashMoney'],
                                oam: false
                            },
                            {
                                prop: 'recycleCashMoney',
                                label: "现金回收",
                                status: false,
                                url: ['/user/query', '/user/bill/backendAddRefundCashMoney'],
                                oam: false
                            },
                        ],
                    },
                    {
                        prop: 'chargesRecord', label: "资费记录", status: false, data: [
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/order/query'],
                                oam: false
                            },
                            {prop: 'detail', label: "详情", status: false, url: ['/user/order/query'], oam: false},
                        ],
                    },
                    {
                        prop: 'commission', label: "佣金明细", status: false, data: [
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/order/query'],
                                oam: false
                            },
                            {prop: 'detail', label: "详情", status: false, url: ['/user/order/query'], oam: false},
                        ],
                    },
                    {
                        prop: "dailyBills", label: "每日账单", status: false, data: [
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/order/queryDayConsumeList'],
                                oam: false
                            },
                            {
                                prop: 'detail',
                                label: "详情",
                                status: false,
                                url: ['/user/order/queryDayConsumeList'],
                                oam: false
                            },
                        ],
                    },
                    {
                        prop: "voucher", label: "代金券", status: false, data: [
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/bill/queryCouponBillList'],
                                oam: false
                            },
                            {
                                prop: 'add',
                                label: "添加代金券",
                                status: false,
                                platform: 'admin',
                                url: ['/user/query', '/user/bill/backendAddCouponMoney'],
                                oam: false
                            },
                            {
                                prop: 'recycle',
                                label: "回收代金券",
                                status: false,
                                platform: 'admin',
                                url: ['/user/bill/backendAddRefundCouponMoney'],
                                oam: false
                            },
                        ],
                    },
                ]
            },
            {
                prop: 'cloudServer ', label: "云服务器", status: false, show: true, data: [
                    {
                        prop: 'vm', label: "云服务器", status: false, data: [
                            {
                                prop: 'create',
                                label: "创建云主机",
                                status: false,
                                url: [
                                    '/user/query',
                                    '/resource/vm/queryTemplateList',
                                    '/resource/image/query',
                                    '/resource/vpc/query',
                                    '/resource/vswitch/query',
                                    '/resource/ip/query',
                                    '/resource/securityGroup/query',
                                    '/resource/house/query',
                                    '/resource/vm/createVPCVM',
                                    '/resource/vm/createClassicVM',
                                    '/price/vm/getVMPrice',
                                    '/resource/group/query'],
                                oam: false
                            },
                            {
                                prop: 'historicalTrafficQuery',
                                label: "历史流量查询",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/getPerformanceData'],
                                oam: false
                            },
                            {
                                prop: 'list',
                                label: "云主机列表",
                                status: false,
                                url: [
                                    '/user/query',
                                    '/resource/vm/updateVMInfo',
                                    '/resource/vm/query',
                                    '/resource/group/query',
                                    '/resource/vm/getVMPowerState'],
                                oam: false
                            },
                            {
                                prop: 'vncLogin',
                                label: "VNC登录",
                                status: false,
                                url: ['/resource/vm/getVNCUrl'],
                                oam: false
                            },
                            {
                                prop: 'log',
                                label: "主机销毁日志",
                                status: false,
                                url: ['/user/query', '/resource/vm/queryDestroyList'],
                                oam: false
                            },
                            {
                                prop: 'detail',
                                label: "主机详情",
                                status: false,
                                url: ['/resource/vm/updateVMInfo'],
                                oam: false
                            },
                            {prop: 'open', label: "开机", status: false, url: ['/resource/vm/startVM'], oam: false},
                            {prop: 'close', label: "关机", status: false, url: ['/resource/vm/shutDownVM'], oam: false},
                            {prop: 'restart', label: "重启", status: false, url: ['/resource/vm/restartVM'], oam: false},
                            {prop: 'destroy', label: "销毁", status: false, url: ['/resource/vm/destroyVM'], oam: false},
                            {
                                prop: 'forceOpen',
                                label: "强制开机",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/startVM'],
                                oam: false
                            },
                            {
                                prop: 'forceClose',
                                label: "强制关机",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/shutDownVM'],
                                oam: false
                            },
                            {
                                prop: 'forceRestart',
                                label: "强制重启",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/restartVM'],
                                oam: false
                            },
                            {
                                prop: 'forceDestroy',
                                label: "强制销毁",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/destroyVM'],
                                oam: false
                            },
                            {
                                prop: 'renew',
                                label: "续费",
                                status: false,
                                url: ['/resource/vm/renewVM', '/price/vm/getRenewVMPrice'],
                                oam: false
                            },
                            {
                                prop: 'modifyBandwidth',
                                label: "修改带宽",
                                status: false,
                                url: ['/resource/bandWidth/setClassicBandWidth'],
                                oam: false
                            },
                            {
                                prop: 'modifyConfig',
                                label: "更改配置",
                                status: false,
                                url: ['/resource/vm/setConfig', '/price/vm/getVMSetConfigPrice'],
                                oam: false
                            },
                            {
                                prop: 'reinstallSystem',
                                label: "重装系统",
                                status: false,
                                url: ['/resource/vm/reloadVMByImage', '/resource/vm/reloadVM', "/price/vm/getVMReinstallPrice"],
                                oam: false
                            },
                            // {
                            //     prop: 'changePackage',
                            //     label: "转包年包月",
                            //     status: false,
                            //     url: ['/resource/vm/changeVMBillingMethodToPackage', '/price/vm/getChangeVMBillingMethodToPackagePrice'],
                            //     oam: false
                            // },
                            {
                                prop: 'automaticStop',
                                label: "自动停机",
                                status: false,
                                url: ['/resource/task/setStopElasticResourceTask'],
                                oam: false
                            },
                            {
                                prop: 'resetPassword',
                                label: "修改密码",
                                status: false,
                                url: ['/resource/vm/setPassword'],
                                oam: false
                            },
                            // {
                            //     prop: 'businessTierChangeConfig',
                            //     label: "业务层调整配置",
                            //     platform: 'admin',
                            //     status: false,
                            //     url: ['/resource/vm/setConfigOnlyApplication'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'setFreeIp',
                            //     label: "设置免费IP",
                            //     platform: 'admin',
                            //     status: false,
                            //     url: ['resource/ip/switchClassicIpBillingMethod'],
                            //     oam: false
                            // },
                            {
                                prop: 'openVNC',
                                label: "开启VNC远程",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/setVNCState'],
                                oam: false
                            },
                            {
                                prop: 'closeVNC',
                                label: "关闭VNC远程",
                                platform: 'admin',
                                status: false,
                                url: ['/resource/vm/setVNCState'],
                                oam: false
                            },
                            // {
                            //     prop: 'priceAdjustment',
                            //     label: "价格调整",
                            //     platform: 'admin',
                            //     status: false,
                            //     url: [],
                            //     oam: false
                            // },
                            {
                                prop: 'autoRenew',
                                label: "自动续费",
                                status: false,
                                url: ["/resource/task/setAutoRenewAndAdjustPackageVMTask", "/price/vm/getRenewVMPrice"],
                                oam: false
                            },
                            {prop: "cancelAutoRenew", label: "取消自动续费", status: false, url: ['/resource/task/deleteProjectTask'], oam: false},
                            {
                                prop: 'expiredChangeConfig',
                                label: "到期更改配置",
                                status: false,
                                url: ["/resource/task/setAutoRenewAndAdjustPackageVMTask", '/price/vm/getVMSetConfigPrice'],
                                oam: false
                            },
                            {prop: 'chargesRecord', label: "资费记录", status: false, url: [], oam: false},
                            {
                                prop: 'mirrorCreate',
                                label: "创建自定义镜像",
                                status: false,
                                url: ['/resource/image/createImageByVM', '/price/image/getImagePrice'],
                                oam: false
                            },
                            {
                                prop: 'joinSecurityGroup',
                                label: "加入安全组",
                                status: false,
                                url: ['/resource/securityGroup/attachVM'],
                                oam: false
                            },
                            {
                                prop: 'removeSecurityGroup',
                                label: "移除安全组",
                                status: false,
                                url: [],
                                oam: false
                            },
                            {prop: 'vmCopy', label: "云主机复制", status: false, url: ['/resource/vm/copyVM'], oam: false},
                            {
                                prop: 'sameConfigurationCreation',
                                label: "相同配置创建",
                                status: false,
                                url: ['/resource/vm/createVPCVM', '/price/vm/getVMPrice'],
                                oam: false
                            },
                            {prop: 'operationLog', label: "操作日志", status: false, url: ['/user/log/query'], oam: false},
                            {
                                prop: "taskScheduled",
                                label: "计划任务",
                                status: false,
                                url: ['/resource/task/queryProjectTaskList', '/resource/task/deleteProjectTask'],
                                oam: false
                            },
                            // {prop: 'resourceTransfer', label: '资源过户', status: false, url: [], oam: false},
                        ]
                    },
                ]
            },
            {
                prop: 'cloudStorage', label: "存储管理", status: false, show: true, data: [
                    {
                        prop: 'disk', label: "云磁盘", status: false, show: true, data: [
                            {
                                prop: 'create',
                                label: "创建云磁盘",
                                status: false,
                                url: [
                                    '/user/query',
                                    '/resource/disk/createDataDisk',
                                    '/resource/disk/createDataDiskAndAttachVM',
                                    '/price/disk/getAttachVMPrice',
                                    '/resource/house/queryGroupList',
                                    '/price/disk/getDiskPrice'],
                                oam: false
                            },
                            // {prop: 'pull', label: "推送云磁盘", status: false, url: [], oam: false},
                            {
                                prop: 'log',
                                label: "磁盘销毁日志",
                                status: false,
                                url: ['/user/query', '/resource/disk/queryDestroyList'],
                                oam: false
                            },
                            {prop: 'detail', label: "详情", status: false, url: [], oam: false},
                            {
                                prop: 'list',
                                label: "列表查看",
                                status: false,
                                url: ['/user/query', '/resource/disk/query', '/resource/disk/updateDiskInfo'],
                                oam: false
                            },
                            {
                                prop: 'bind',
                                label: "挂载",
                                status: false,
                                url: ['/resource/disk/attachVM', '/price/disk/getAttachVMPrice'],
                                oam: false
                            },
                            // {
                            //     prop: 'unbind',
                            //     label: "卸载",
                            //     status: false,
                            //     url: ['/resource/disk/detach', '/price/disk/getDetachPrice'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'renew',
                            //     label: "续费",
                            //     status: false,
                            //     url: ['/resource/disk/renewDisk', '/price/disk/getRenewDiskPrice'],
                            //     oam: false
                            // },
                            // {prop: 'destroy', label: "销毁", status: false, url: ['/resource/disk/destroy'], oam: false},
                            {
                                prop: 'autoSnap',
                                label: "自动快照配置",
                                status: false,
                                url: ['/resource/snap/setAutoSnapRule', '/price/snap/getSnapPrice'],
                                oam: false
                            },
                            {
                                prop: 'fixedSnap',
                                label: "固定快照",
                                status: false,
                                url: ['/resource/snap/createFixedDiskSnap', '/price/snap/getSnapPrice'],
                                oam: false
                            },
                            {
                                prop: 'mirrorCreate',
                                label: "创建自定义镜像",
                                status: false,
                                url: ['/resource/image/createImageByDisk', '/price/image/getImagePrice'],
                                oam: false
                            },
                            {prop: 'chargesRecord', label: "资费记录", status: false, url: [], oam: false},
                            // {prop: 'copy', label: "克隆磁盘", status: false, url: ['/resource/disk/cloneDisk'], oam: false},
                            // {
                            //     prop: 'modification',
                            //     label: "修改磁盘信息",
                            //     status: false,
                            //     url: ['/resource/disk/updateSystemDiskInfo'],
                            //     oam: false
                            // },
                        ]
                    },
                    {
                        prop: 'snap', label: "云快照", status: false, show: true, data: [
                            {
                                prop: 'fixedSnapList',
                                label: "固定快照列表",
                                status: false,
                                url: ['/user/query', '/resource/snap/query', '/resource/snap/updateSnapInfo'],
                                oam: false
                            },
                            {prop: 'fixedSnapDetail', label: "固定快照详情", status: false, url: [], oam: false},
                            {prop: 'fixedSnapGenerateVm', label: "固定快照生成云主机", status: false, url: [], oam: false},
                            // {
                            //     prop: 'fixedSnapGenerateDisk',
                            //     label: "固定快照生成磁盘",
                            //     status: false,
                            //     url: ['/resource/snap/createDiskBySnap'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'fixedSnapRenew',
                            //     label: "固定快照续费",
                            //     status: false,
                            //     url: ['/resource/snap/renewSnap'],
                            //     oam: false
                            // },
                            {
                                prop: 'fixedSnapDataRecovery',
                                label: "固定快照数据恢复",
                                status: false,
                                url: ['/resource/snap/restoreDiskData'],
                                oam: false
                            },
                            {
                                prop: 'fixedSnapDestroy',
                                label: "固定快照销毁",
                                status: false,
                                url: ['/resource/snap/destroySnap'],
                                oam: false
                            },
                            // {prop: 'fixedSnapChargesRecord', label: "固定快照资费记录", status: false, url: [], oam: false},
                            {
                                prop: 'autoSnapList',
                                label: "自动快照列表",
                                status: false,
                                url: ['/user/query', '/resource/snap/query', '/resource/snap/updateSnapInfo'],
                                oam: false
                            },
                            {prop: 'autoSnapDetail', label: "自动快照详情", status: false, url: [], oam: false},
                            {prop: 'autoSnapGenerateVm', label: "自动快照生成云主机", status: false, url: [], oam: false},
                            // {
                            //     prop: 'autoSnapGenerateDisk',
                            //     label: "自动快照生成磁盘",
                            //     status: false,
                            //     url: ['/resource/snap/createDiskBySnap'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'autoSnapRenew',
                            //     label: "自动快照续费",
                            //     status: false,
                            //     url: ['/resource/snap/renewSnap'],
                            //     oam: false
                            // },
                            {
                                prop: 'autoSnapDataRecovery',
                                label: "自动快照数据恢复",
                                status: false,
                                url: ['/resource/snap/restoreDiskData'],
                                oam: false
                            },
                            {
                                prop: 'autoSnapDestroy',
                                label: "自动快照销毁",
                                status: false,
                                url: ['/resource/snap/destroySnap'],
                                oam: false
                            },
                            {
                                prop: 'autoSnapAutoChangeFixed',
                                label: "自动快照转固化快照",
                                status: false,
                                url: ['/resource/snap/changeAutoToFixed'],
                                oam: false
                            },
                            {
                                prop: 'autoSnapConfigList',
                                label: "自动快照配置列表",
                                status: false,
                                url: ['/user/query', '/resource/snap/querySnapRuleList'],
                                oam: false
                            },
                            {
                                prop: 'autoSnapConfigDestroy',
                                label: "自动快照配置销毁",
                                status: false,
                                url: ['/resource/snap/destroySnapRule'],
                                oam: false
                            },
                            {
                                prop: 'autoSnapConfigModify',
                                label: "自动快照配置修改",
                                status: false,
                                url: ['/resource/snap/editSnapRule'],
                                oam: false
                            },
                            {
                                prop: 'backupRestoreRecordList',
                                label: "备份恢复记录列表",
                                status: false,
                                url: ['/user/query', '/resource/snap/queryRestoreList'],
                                oam: false
                            },
                            {
                                prop: 'logList',
                                label: "快照销毁记录列表",
                                status: false,
                                url: ['/user/query', '/resource/snap/queryDestroyList'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: 'image', label: "镜像管理", status: false, show: true, data: [
                            {
                                prop: 'create',
                                label: "创建镜像",
                                status: false,
                                url: ['/user/query', '/resource/house/query', '/resource/vm/query', '/resource/disk/query', '/price/image/getImagePrice', '/resource/image/createImageByVM'],
                                oam: false
                            },
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/resource/image/query', '/resource/image/updateImageInfo'],
                                oam: false
                            },
                            {
                                prop: 'log',
                                label: "销毁日志",
                                status: false,
                                url: ['/user/query', '/resource/image/queryDestroyList'],
                                oam: false
                            },
                            {
                                prop: 'detail',
                                label: "详情",
                                status: false,
                                url: ['/resource/image/query', '/resource/image/updateImageInfo'],
                                oam: false
                            },
                            {
                                prop: 'imageDiskList',
                                label: "镜像磁盘列表",
                                status: false,
                                url: ['/user/query', '/resource/image/query'],
                                oam: false
                            },
                            // {
                            //     prop: 'renew',
                            //     label: "续费",
                            //     status: false,
                            //     url: ['/resource/image/renewImage', '/price/image/getRenewImagePrice'],
                            //     oam: false
                            // },
                            // {prop: 'createVm', label: "创建实例", status: false, url: [], oam: false},
                            {
                                prop: 'destroy',
                                label: "销毁镜像",
                                status: false,
                                url: ['/resource/image/destroyImage'],
                                oam: false
                            },
                            // {prop: 'derivedVm', label: "派生实例", status: false, url: [], oam: false},
                            // {
                            //     prop: 'imageRemark',
                            //     label: "镜像描述修改",
                            //     status: false,
                            //     url: ['/resource/image/updateImageInfo'],
                            //     oam: false
                            // },
                        ]
                    },
                ]
            },
            {
                prop: 'networkSecurity', label: "网络安全", status: false, show: true, data: [
                    {
                        prop: "ip", label: "弹性IP", status: false, show: true, data: [
                            {
                                prop: "create",
                                label: "创建云IP",
                                status: false,
                                url: [
                                    '/user/query',
                                    '/resource/ip/createVPCIP',
                                    '/resource/ip/createVPCIPAndAttachNAT',
                                    '/resource/ip/createVPCIPAndAttachRDS',
                                    '/resource/ip/createVPCIPAndAttachSLB',
                                    '/resource/ip/createVPCIPAndAttachVM',
                                    '/price/ip/getVPCIPPrice'
                                ],
                                oam: false
                            },
                            {prop: "list", label: "列表", status: false, url: ['/resource/ip/query'], oam: false},
                            {
                                prop: "bwImage",
                                label: "带宽监控图",
                                status: false,
                                url: ['/resource/ip/getPerformanceData'],
                                oam: false
                            },
                            {
                                prop: "detail",
                                label: "详情",
                                status: false,
                                url: ['/resource/ip/query', '/resource/ip/updateIPInfo'],
                                oam: false
                            },
                            {
                                prop: "mount",
                                label: "挂载",
                                status: false,
                                url: ['/resource/nat/attachIP', '/resource/slb/attachIP', '/resource/vm/attachIP', '/resource/rds/attachIP'],
                                oam: false
                            },
                            // {prop: "unmount", label: "卸载", status: false, url: ['/resource/ip/detach'], oam: false},
                            // {prop: "destroy", label: "销毁", status: false, url: ['/resource/ip/destroy'], oam: false},
                            {
                                prop: "changeBandwitch",
                                label: "修改带宽",
                                status: false,
                                url: ['/resource/vm/query', '/resource/bandWidth/setVpcBandWidth', '/price/bandWidth/getVpcBandWidthSettingPrice'],
                                oam: false
                            },
                            // {
                            //     prop: "setNetworkTransmission",
                            //     label: "设置内网传输",
                            //     status: false,
                            //     url: ['/resource/ip/setIPPrivateTransfer'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "toPackage",
                            //     label: "转包年包月",
                            //     status: false,
                            //     url: ['/resource/ip/changeIPBillingMethodToPackage'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "unmountAndDestroy",
                            //     label: "卸载并销毁IP",
                            //     status: false,
                            //     url: ['/resource/ip/detach'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "renew",
                            //     label: "续费",
                            //     status: false,
                            //     url: ['/resource/ip/renewIP'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "NetworkTransmissionList",
                            //     label: "内网传输列表",
                            //     status: false,
                            //     url: ['/user/query', '/resource/ip/queryPrivateTransferList'],
                            //     oam: false
                            // },
                            {
                                prop: "destroyLog",
                                label: "销毁IP日志",
                                status: false,
                                url: ['/user/query', '/resource/ip/queryDestroyList'],
                                oam: false
                            },
                            // {
                            //     prop: "cancelNetworkTransmission",
                            //     label: "取消内网传输",
                            //     status: false,
                            //     url: ['/resource/ip/destroyIPPrivateTransfer'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "replace",
                            //     label: '替换IP',
                            //     status: false,
                            //     url: [],
                            //     oam: false,
                            // }
                        ]
                    },
                    {
                        prop: 'vpc', label: "VPC", status: false, show: true, data: [
                            {
                                prop: "create",
                                label: "创建VPC网络",
                                status: false,
                                url: ['/user/query', '/resource/vpc/createVPCAndVswitch'],
                                oam: false
                            },
                            {
                                prop: "list",
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/resource/vpc/query', '/resource/vpc/updateVPCInfo'],
                                oam: false
                            },
                            {
                                prop: "topologyMap",
                                label: "查看拓扑图",
                                status: false,
                                url: ['/resource/vpc/getVPCTopology'],
                                oam: false
                            },
                            {prop: "detail", label: "详情", status: false, url: ['/resource/vpc/query'], oam: false},
                            {prop: "delete", label: "删除", status: false, url: ['/resource/vpc/destroy'], oam: false},
                            {
                                prop: "destroyLog",
                                label: "VPC销毁日志列表",
                                status: false,
                                url: ['/user/query', '/resource/vpc/queryDestroyList'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: 'vswitch', label: "交换机", status: false, show: true, data: [
                            {
                                prop: 'create',
                                label: "创建交换机",
                                status: false,
                                url: ['/user/query', '/resource/vswitch/createVSwitch'],
                                oam: false
                            },
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/resource/vswitch/query', '/resource/vswitch/updateVSwitchInfo'],
                                oam: false
                            },
                            {prop: 'detail', label: "详情", status: false, url: ['/resource/vswitch/query'], oam: false},
                            {
                                prop: 'delete',
                                label: "删除",
                                status: false,
                                url: ['/resource/vswitch/destroy', '/resource/vswitch/updateVSwitchInfo'],
                                oam: false
                            },
                            {
                                prop: 'log',
                                label: "交换机销毁日志列表",
                                status: false,
                                url: ['/user/query', '/resource/vswitch/queryDestroyList'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: 'routeTable', label: "路由表", status: false, show: true, data: [
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/resource/routeTable/query', '/resource/routeTable/updateRouteTableInfo'],
                                oam: false
                            },
                            {
                                prop: 'detail',
                                label: "详情",
                                status: false,
                                url: ['/resource/routeTable/query', '/resource/routeTable/updateRouteTableInfo'],
                                oam: false
                            },
                            {
                                prop: 'log',
                                label: "路由表销毁日志列表",
                                status: false,
                                url: ['/user/query', "/resource/routeTable/queryDestroyList"],
                                oam: false
                            },
                            {
                                prop: 'create',
                                label: "添加路由条目",
                                status: false,
                                url: ['/resource/route/query', '/resource/route/addRoute', '/resource/vm/query'],
                                oam: false
                            },
                            {
                                prop: 'delete',
                                label: "删除路由条目",
                                status: false,
                                url: ['/resource/route/destroy'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: 'nat', label: "NAT", status: false, show: true, data: [
                            {
                                prop: "list",
                                label: "NAT列表",
                                status: false,
                                url: ['/user/query', '/resource/nat/query', '/resource/nat/updateNATInfo'],
                                oam: false
                            },
                            {
                                prop: "create",
                                label: "创建NAT",
                                status: false,
                                url: ['/user/query', '/resource/nat/createNAT'],
                                oam: false
                            },
                            {
                                prop: "detail",
                                label: "详情",
                                status: false,
                                url: ['/resource/nat/query', '/resource/nat/updateNATInfo'],
                                oam: false
                            },

                            {prop: "delete", label: "销毁", status: false, url: ['/resource/nat/destroy'], oam: false},
                            {
                                prop: "forceDelete",
                                label: "强制销毁",
                                status: false,
                                url: ['/resource/nat/forceDestroy'],
                                oam: false
                            },
                            {
                                prop: "setDnat",
                                label: "设置DNAT",
                                status: false,
                                url: ['/resource/nat/addDNAT', '/resource/nat/destroyDNAT'],
                                oam: false
                            },
                            {
                                prop: "setSnat",
                                label: "设置SNAT",
                                status: false,
                                url: ['/resource/nat/addSNAT', '/resource/nat/destroySNAT'],
                                oam: false
                            },
                            {
                                prop: "mountIp",
                                label: "挂载弹性公网IP",
                                status: false,
                                url: ['/resource/nat/attachIP'],
                                oam: false
                            },
                            // {
                            //     prop: "unmountIp",
                            //     label: "卸载弹性公网IP",
                            //     status: false,
                            //     url: ['/resource/ip/detach'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "autoStop",
                            //     label: "自动停机",
                            //     status: false,
                            //     url: ['/resource/task/setStopElasticResourceTask'],
                            //     oam: false
                            // },
                            {
                                prop: "destroyLog",
                                label: "NAT网关销毁日志",
                                status: false,
                                url: ['/user/query', '/resource/nat/queryDestroyList'],
                                oam: false
                            },
                            {
                                prop: "dnatList",
                                label: "DNAT列表",
                                status: false,
                                url: ['/resource/nat/queryDNAT'],
                                oam: false
                            },
                            {
                                prop: "snatList",
                                label: "SNAT列表",
                                status: false,
                                url: ['/resource/nat/querySNAT'],
                                oam: false
                            },
                            {
                                prop: "taskList",
                                label: "计划任务",
                                status: false,
                                url: ['/resource/task/queryProjectTaskList', '/resource/task/deleteProjectTask'],
                                oam: false
                            },
                            {prop: "renew", label: "续费", status: false, url: ['/resource/nat/renewNAT'], oam: false},
                            {prop: "autoRenew", label: "自动续费", status: false, url: ['/resource/task/setAutoRenewAndAdjustPackageNatTask'], oam: false},
                            {prop: "cancelAutoRenew", label: "取消自动续费", status: false, url: ['/resource/task/deleteProjectTask'], oam: false},
                        ]
                    },
                    {
                        prop: 'slb', label: "SLB均衡负载", status: false, show: true, data: [
                            {
                                prop: "list",
                                label: "SLB列表",
                                status: false,
                                url: ['/user/query', '/resource/slb/query', '/resource/slb/updateSLBInfo'],
                                oam: false
                            },
                            {
                                prop: "create",
                                label: "创建",
                                status: false,
                                url: ['/user/query', '/resource/slb/createSLB', '/price/slb/getSLBPrice', '/resource/house/query'],
                                oam: false
                            },
                            {
                                prop: "monitorList",
                                label: "监听管理",
                                status: false,
                                url: ['/resource/listener/query'],
                                oam: false
                            },
                            {
                                prop: "detail",
                                label: "详情",
                                status: false,
                                url: ['/resource/slb/query', '/resource/slb/updateSLBInfo'],
                                oam: false
                            },
                            {prop: "start", label: "启动服务", status: false, url: ['/resource/slb/startSLB'], oam: false},
                            {prop: "stop", label: "停止服务", status: false, url: ['/resource/slb/stopSLB'], oam: false},
                            {prop: "destroy", label: "销毁", status: false, url: ['/resource/slb/destroy'], oam: false},
                            {prop: "autoRenew", label: "自动续费", status: false, url: ['/resource/task/setAutoRenewAndAdjustPackageNatTask'], oam: false},
                            {prop: "cancelAutoRenew", label: "取消自动续费", status: false, url: ['/resource/task/deleteProjectTask'], oam: false},
                            {
                                prop: "renew",
                                label: "续费",
                                status: false,
                                url: ['/resource/slb/renewSLB', '/price/slb/getRenewSLBPrice'],
                                oam: false
                            },
                            {
                                prop: "mountIp",
                                label: "挂载弹性公网IP",
                                status: false,
                                url: ['/resource/slb/attachIP'],
                                oam: false
                            },
                            // {
                            //     prop: "unmountIp",
                            //     label: "卸载弹性公网IP",
                            //     status: false,
                            //     url: ['/resource/ip/detach'],
                            //     oam: false
                            // },
                            // {
                            //     prop: "autoStop",
                            //     label: "自动停机",
                            //     status: false,
                            //     url: ['/resource/task/setStopElasticResourceTask'],
                            //     oam: false
                            // },
                            {
                                prop: "destroyLog",
                                label: "销毁日志",
                                status: false,
                                url: ['/user/query', '/resource/slb/queryDestroyList'],
                                oam: false
                            },
                            {
                                prop: "strategyList",
                                label: "访问策略列表",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/queryPackage'],
                                oam: false
                            },
                            {
                                prop: "taskList",
                                label: "计划任务",
                                status: false,
                                url: ['/resource/task/queryProjectTaskList', '/resource/task/deleteProjectTask'],
                                oam: false
                            },
                            {
                                prop: "addMonitor",
                                label: "添加监听",
                                status: false,
                                url: ['/resource/listener/createHTTPListener', '/resource/listener/createTCPListener'],
                                oam: false
                            },
                            {
                                prop: "adjustMonitor",
                                label: "修改监听",
                                status: false,
                                url: ['/resource/listener/updateHTTPListener', '/resource/listener/updateTCPListener'],
                                oam: false
                            },
                            {
                                prop: "startMonitor",
                                label: "启动监听",
                                status: false,
                                url: ['/resource/listener/StartSLBListener'],
                                oam: false
                            },
                            {
                                prop: "stopMonitor",
                                label: "停止监听",
                                status: false,
                                url: ['/resource/listener/StopSLBListener'],
                                oam: false
                            },
                            {
                                prop: "deleteMonitor",
                                label: "删除监听",
                                status: false,
                                url: ['/resource/listener/destroyListener'],
                                oam: false
                            },
                            {
                                prop: "openStrategy",
                                label: "开启访问控制",
                                status: false,
                                url: ['/resource/listener/updateTCPListener', '/resource/listener/updateHTTPListener'],
                                oam: false
                            },
                            {
                                prop: "closeStrategy",
                                label: "关闭访问控制",
                                status: false,
                                url: ['/resource/listener/updateTCPListener', '/resource/listener/updateHTTPListener'],
                                oam: false
                            },
                            {
                                prop: "setStrategy",
                                label: "设置访问控制策略",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/updatePackage'],
                                oam: false
                            },
                            {
                                prop: "monitorDetail",
                                label: "监听详情",
                                status: false,
                                url: ['/resource/listener/query'],
                                oam: false
                            },
                            {
                                prop: "backendServeList",
                                label: "后端服务器列表",
                                status: false,
                                url: ['/resource/backendServer/query'],
                                oam: false
                            },
                            {
                                prop: "addBackendServe",
                                label: "添加后端服务器",
                                status: false,
                                url: ['/resource/backendServer/add'],
                                oam: false
                            },
                            {
                                prop: "adjustBackendServe",
                                label: "修改后端服务器",
                                status: false,
                                url: ['/resource/backendServer/update'],
                                oam: false
                            },
                            {
                                prop: "removeBackendServe",
                                label: "移除后端服务器",
                                status: false,
                                url: ['/resource/backendServer/delete'],
                                oam: false
                            },
                            {
                                prop: "addStrategy",
                                label: "添加访问策略",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/createPackage'],
                                oam: false
                            },
                            {
                                prop: "deleteStrategy",
                                label: "删除访问策略",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/destroyPackage'],
                                oam: false
                            },
                            {
                                prop: "sourceAddressList",
                                label: "源地址列表",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/queryAce'],
                                oam: false
                            },
                            {
                                prop: "addSourceAddress",
                                label: "添加源地址",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/addAce'],
                                oam: false
                            },
                            {
                                prop: "deleteSourceAddress",
                                label: "删除源地址",
                                status: false,
                                url: ['/resource/accessControlEntryPackage/destroyAce'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: 'rds', label: "RDS云数据库", status: false, show: true, data: [
                            {prop: 'create', label: "创建", status: false, url: ['/resource/rds/createRDS'], oam: false},
                            {prop: 'list', label: "列表", status: false, url: ['/resource/rds/query'], oam: false},
                            {prop: 'monitoring', label: "监控", status: false, url: ['/resource/rds/getStatistic'], oam: false},
                            {prop: 'detail', label: "详情", status: false, url: ['/resource/rds/query'], oam: false},
                            {prop: 'upgradeVersion', label: "升级功能版本", status: false, url: ['/resource/rds/getRDSVersionByGroupID','/resource/rds/upgradeVersion'], oam: false},
                            {prop: 'start', label: "启动服务", status: false, url: ['/resource/rds/startService'], oam: false},
                            {prop: 'stop', label: "停止服务", status: false, url: ['/resource/rds/stopService'], oam: false},
                            {prop: 'restart', label: "重启服务", status: false, url: ['/resource/rds/restartService'], oam: false},
                            {prop: 'destroy', label: "销毁", status: false, url: ['/resource/rds/destroy'], oam: false},
                            // {prop: 'forceDestroy', label: "强制销毁", status: false, url: ['/resource/rds/destroy'], oam: false},
                            {prop: 'expiredModifyConfig', label: "到期更改配置", status: false, url: ['/resource/task/setAutoRenewAndAdjustPackageRDSTask'], oam: false},
                            {prop: 'modifyConfig', label: "更改配置", status: false, url: ['/resource/rds/setConfig'], oam: false},
                            {prop: 'renew', label: "续费", status: false, url: ['/resource/rds/renewRDS'], oam: false},
                            {prop: 'autoRenew', label: "自动续费", status: false, url: ['resource/task/setAutoRenewAndAdjustPackageRDSTask'], oam: false},
                            {prop: 'cancelAutoRenew', label: "取消自动续费", status: false, url: ['/resource/task/deleteProjectTask'], oam: false},
                            {prop: 'scheduledTask', label: "计划任务", status: false, url: ['/resource/task/queryProjectTaskList'], oam: false},
                            // {prop: 'toPackage', label: "转包年包月", status: false, url: ['/resource/rds/changeRDSBillingMethodToPackage'], oam: false},
                            {prop: 'masterSlave', label: "主从切换", status: false, url: ['/resource/rds/switchMasterSlave'], oam: false},
                            {prop: 'addSecurityGroup', label: "加入安全组", status: false, url: ['/resource/securityGroup/query'], oam: false},
                            {prop: 'removeSecurityGroup', label: "移除安全组", status: false, url: ['/resource/securityGroup/detachRDS'], oam: false},

                            {prop: 'backupRecovery', label: "备份恢复", status: false, url: ['/resource/rds/queryBackupList'], oam: false},
                            {prop: 'account', label: "账号管理", status: false, url: ['/resource/rds/queryUserList'], oam: false},
                            {prop: 'paramsConfig', label: "参数配置", status: false, url: ['/resource/rds/getParameter'], oam: false},
                            // {prop: 'sql', label: "SQL审计", status: false, url: [], oam: false},
                            {prop: 'operateLog', label: "操作日志", status: false, url: ['/user/log/query'], oam: false},
                            {prop: 'destroyLog', label: "销毁日志", status: false, url: ['/resource/rds/queryDestroyList'], oam: false},
                        ]
                    },
                    {
                        prop: 'securityGroup', label: "安全组", status: false, show: true, data: [
                            {
                                prop: 'list',
                                label: "安全组列表",
                                status: false,
                                url: ['/user/query', '/resource/securityGroup/query', '/resource/securityGroup/update'],
                                oam: false
                            },
                            {
                                prop: 'create',
                                label: "创建安全组",
                                status: false,
                                url: ['/user/query', '/resource/securityGroup/create'],
                                oam: false
                            },
                            {
                                prop: 'detail',
                                label: "详情",
                                status: false,
                                url: ['/resource/securityGroup/query', '/resource/securityGroup/update'],
                                oam: false
                            },
                            {
                                prop: 'rule',
                                label: "配置规则",
                                status: false,
                                url: ['/resource/securityRules/query'],
                                oam: false
                            },
                            {
                                prop: 'clone',
                                label: "克隆",
                                status: false,
                                url: ['/resource/securityGroup/create'],
                                oam: false
                            },
                            {
                                prop: 'destroyGroup',
                                label: "删除",
                                status: false,
                                url: ['/resource/securityGroup/delete'],
                                oam: false
                            },
                            {
                                prop: 'config',
                                label: "关联实例",
                                status: false,
                                url: ['/resource/securityGroup/queryVMInSecurityGroup'],
                                oam: false
                            },
                            // {
                            //     prop: 'limitList',
                            //     label: "安全组限制列表",
                            //     status: false,
                            //     url: ['/user/query', '/resource/securityGroup/querySecurityGroupLimitList'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'setLimit',
                            //     label: "设置安全组限制",
                            //     status: false,
                            //     url: ['/resource/securityGroup/setSecurityGroupLimitConfig'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'deleteLimit',
                            //     label: "删除安全组限制",
                            //     status: false,
                            //     url: ['resource/securityGroup/deleteSecurityGroupLimitConfig'],
                            //     oam: false
                            // },
                            // {
                            //     prop: 'modifyLimit',
                            //     label: "编辑安全组限制",
                            //     status: false,
                            //     url: ['resource/securityGroup/setSecurityGroupLimitConfig'],
                            //     oam: false
                            // },
                            {
                                prop: 'log',
                                label: "安全组销毁日志",
                                status: false,
                                url: ['/user/query', '/resource/securityGroup/queryDestroyList'],
                                oam: false
                            },
                            {
                                prop: "createRules",
                                label: "添加安全组规则",
                                status: false,
                                url: ["/resource/securityRules/create"],
                                oam: false
                            },
                            {
                                prop: "modifyRules",
                                label: "编辑安全组规则",
                                status: false,
                                url: ["/resource/securityRules/update"],
                                oam: false
                            },
                            {
                                prop: "deleteRules",
                                label: "删除安全组规则",
                                status: false,
                                url: ["/resource/securityRules/delete"],
                                oam: false
                            },
                            {
                                prop: "attachVM",
                                label: "添加实例",
                                status: false,
                                url: ["/resource/securityGroup/attachVM"],
                                oam: false
                            },
                            {
                                prop: "detachVM",
                                label: "移除实例",
                                status: false,
                                url: ["/resource/securityGroup/detachVM"],
                                oam: false
                            },
                            {
                                prop: "analysisExcel",
                                label: "导入安全组规则",
                                status: false,
                                url: ["/resource/securityRules/analysisExcel"],
                                oam: false
                            },

                        ]
                    },
                ]
            },
            {
                prop: 'task', label: "任务队列", status: false, show: true, data: [
                    {
                        prop: 'task', label: "任务队列", status: false, show: true, data: [
                            {
                                prop: 'list',
                                label: "任务信息列表",
                                status: false,
                                url: ['/user/query', '/task/async/query'],
                                oam: false
                            },
                            {prop: 'detail', label: "详情", status: false, url: ['/task/async/query'], oam: false},
                            {prop: 'delete', label: "删除", status: false, url: ['/task/async/delete'], oam: false},
                            {
                                prop: 'statistics',
                                label: "任务统计分析",
                                status: false,
                                url: ['/task/async/queryStatistics'],
                                oam: false
                            },
                        ]
                    },
                ]
            },

            // {
            //     prop: 'discount', label: "折扣管理", status: false, show: true, data: [
            //         {
            //             prop: "discount", label: "折扣管理", status: false, data: [
            //                 {
            //                     prop: "list",
            //                     label: "列表",
            //                     status: false,
            //                     url: ['/user/query', '/user/discount/queryUserDiscount'],
            //                     oam: false
            //                 },
            //                 {
            //                     prop: "create",
            //                     label: "新建折扣",
            //                     status: false,
            //                     url: ['/user/query', '/user/discount/initDiscount'],
            //                     oam: false
            //                 },
            //                 {
            //                     prop: "add",
            //                     label: "添加折扣",
            //                     status: false,
            //                     url: ['/user/discount/initDiscount'],
            //                     oam: false
            //                 },
            //                 {
            //                     prop: "modify",
            //                     label: "修改折扣",
            //                     status: false,
            //                     url: ['/user/discount/updateDiscount'],
            //                     oam: false
            //                 },
            //                 {
            //                     prop: "delete",
            //                     label: "删除折扣",
            //                     status: false,
            //                     url: ['/user/discount/deleteDiscount'],
            //                     oam: false
            //                 },
            //             ]
            //         },
            //     ]
            // },
            {
                prop: 'clientLog', label: "操作日志", status: false, show: true, data: [
                    {
                        prop: "clientLog", label: "操作日志", status: false, data: [
                            {
                                prop: "list",
                                label: "列表",
                                status: false,
                                url: ['/user/query', '/user/log/query'],
                                oam: false
                            },
                        ]
                    },
                ]
            },
            {
                prop: 'accountPermission', label: "账号管理", status: false, show: true, data: [
                    {
                        prop: 'childAccount', label: '子账号管理', status: false, data: [
                            {prop: 'list', label: "列表", status: false, url: ['/user/query'], oam: false},
                            // {prop: 'create', label: "添加用户", status: false, url: ['/user/backendAddUser'], oam: false},
                            {prop: 'setRole', label: "设置角色", status: false, url: ['/user/privilege/setUserRole'], oam: false},

                        ]
                    },
                    {
                        prop: 'role', label: "角色管理", status: false, data: [
                            {
                                prop: 'create',
                                label: "添加角色",
                                status: false,
                                url: ['/user/privilege/addRole'],
                                oam: false
                            },
                            {
                                prop: 'list',
                                label: "列表",
                                status: false,
                                url: ['/user/privilege/queryRoleByMultipleParam'],
                                oam: false
                            },
                            {
                                prop: 'destroy',
                                label: "删除",
                                status: false,
                                url: ['/user/privilege/deleteRole'],
                                oam: false
                            },
                            {
                                prop: 'modify',
                                label: "修改",
                                status: false,
                                url: ['/user/privilege/getRoleInfoByID', '/user/privilege/updateRole'],
                                oam: false
                            },
                            // {
                            //     prop: 'set',
                            //     label: "设置角色权限",
                            //     status: false,
                            //     url: ['/user/privilege/setRoleDataAuthority'],
                            //     oam: false
                            // },
                        ]
                    },

                    // {
                    //     prop: 'department', label: "部门管理", status: false, data: [
                    //         {prop: 'list', label: "列表", status: false, url: ['/user/department/query'], oam: false},
                    //         {prop: 'create', label: "新建部门", status: false, url: ['/user/department/add'], oam: false},
                    //         {
                    //             prop: 'modify',
                    //             label: "修改部门",
                    //             status: false,
                    //             url: ['/user/department/update'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'destory',
                    //             label: "删除部门",
                    //             status: false,
                    //             url: ['/user/department/delete'],
                    //             oam: false
                    //         },
                    //         {
                    //             prop: 'modifyMember',
                    //             label: "移出/增加部门成员",
                    //             status: false,
                    //             url: ['/user/department/query', '/user/query', '/user/department/batchAttachDepartment'],
                    //             oam: false
                    //         },
                    //     ]
                    // },
                ]
            },
        ]
    },
    // resourceManagement: {
    //     label: "资源管理模块", data: [
    //         {
    //             label: "资源总览", status: false, show: true, data: [
    //                 {
    //                     prop: 'groupStatistics', label: "资源总览", status: false, show: true, data: [
    //                         {
    //                             prop: 'getInfo',
    //                             label: "获取节点资源池统计信息",
    //                             status: false,
    //                             url: ['/groupStatistics/getInfo'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'timingExport',
    //                             label: "生成数据",
    //                             status: false,
    //                             url: ['/groupStatistics/timingExport'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'exportss',
    //                             label: "导出",
    //                             status: false,
    //                             url: ['/groupStatistics/exportss'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },


    //                 {
    //                     prop: 'ha', label: "HA统计", status: false, show: true, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/ha/query'], oam: true},
    //                     ]
    //                 },


    //             ]
    //         },
    //         {
    //             label: "告警", status: false, show: true, data: [


    //                 {
    //                     prop: 'alarm', label: "告警列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/alarm/query'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/alarm/delete'], oam: true},
    //                     ]
    //                 },


    //             ]
    //         },
    //         {
    //             label: "节点管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'group', label: "子节点列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/group/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/group/add'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/group/delete'], oam: true},
    //                         {prop: 'update', label: "修改", status: false, url: ['/group/update'], oam: true},


    //                         {
    //                             prop: 'getRelateGroup',
    //                             label: "获取同一个可用区关联的子节点",
    //                             status: false,
    //                             url: ['/group/getRelateGroup'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'updateDefaultComputerSpecs',
    //                             label: "修改默认规格",
    //                             status: false,
    //                             url: ['/group/updateDefaultComputerSpecs'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'addOrUpdateCheck',
    //                             label: "添加修改验证",
    //                             status: false,
    //                             url: ['/group/addOrUpdateCheck'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'userHouse', label: "独立节点设置", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/userHouse/query'], oam: true},
    //                         {prop: 'add', label: "添加/修改", status: false, url: ["/userHouse/addOrUpdate"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/userHouse/delete'], oam: true},
    //                         {
    //                             prop: 'queryCustomerSimpleList',
    //                             label: "查询客户简单列表",
    //                             status: false,
    //                             url: ['/userHouse/queryCustomerSimpleList'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'queryAdminInfo',
    //                             label: "查询管理员信息",
    //                             status: false,
    //                             url: ['/userHouse/queryAdminInfo'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'userHouseBandWidthFlow', label: "流量计费节点设置", status: false, data: [
    //                         {
    //                             prop: 'list',
    //                             label: "列表",
    //                             status: false,
    //                             url: ['/userHouseBandWidthFlow/query'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'add',
    //                             label: "添加",
    //                             status: false,
    //                             url: ['/userHouseBandWidthFlow/addOrUpdate'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'update',
    //                             label: "修改",
    //                             status: false,
    //                             url: ['/userHouseBandWidthFlow/addOrUpdate'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'delete',
    //                             label: "删除",
    //                             status: false,
    //                             url: ['/userHouseBandWidthFlow/delete'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'groupDNS', label: "节点DNS", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/groupDNS/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/groupDNS/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ['/groupDNS/update'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/groupDNS/delete'], oam: true},
    //                     ]
    //                 },
    //                 {
    //                     prop: 'pool', label: "资源池列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/pool/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/pool/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ['/pool/update'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/pool/delete'], oam: true},

    //                     ]
    //                 },
    //                 {
    //                     prop: 'poolSpecs', label: "计算规格列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/poolSpecs/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/poolSpecs/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ['/poolSpecs/update'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/poolSpecs/delete'], oam: true},
    //                     ]
    //                 },
    //                 {
    //                     prop: 'zone', label: "节点列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/zone/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/zone/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ['/zone/update'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/zone/delete'], oam: true},

    //                         {
    //                             prop: 'queryGroupZone',
    //                             label: "节点区域列表",
    //                             status: false,
    //                             url: ['/zone/queryGroupZone'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改开放购买状态",
    //                             status: false,
    //                             url: ['/zone/changeAvailable'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeState',
    //                             label: "修改可用状态",
    //                             status: false,
    //                             url: ['/zone/changeState'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'updateECFLocation',
    //                             label: "修改ECF资源location信息中的可用区",
    //                             status: false,
    //                             url: ['/zone/updateECFLocation'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "设备管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'host', label: "物理机列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/host/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/host/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ['/host/update'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/host/delete'], oam: true},

    //                         {
    //                             prop: 'queryList',
    //                             label: "列表(不聚合)",
    //                             status: false,
    //                             url: ['/host/queryList'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'getHostNuma',
    //                             label: "获取主机NUMA",
    //                             status: false,
    //                             url: ['/host/getHostNuma'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'getHostVCpuPin',
    //                             label: "获取绑定核数详细",
    //                             status: false,
    //                             url: ['/host/getHostVCpuPin'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'addOrUpdateCheck',
    //                             label: "添加修改验证",
    //                             status: false,
    //                             url: ['/host/addOrUpdateCheck'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'getStorageList',
    //                             label: "指定物理资源的LUN列表",
    //                             status: false,
    //                             url: ['/host/getStorageList'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'getHostInfo',
    //                             label: "指定主机信息",
    //                             status: false,
    //                             url: ['/host/getHostInfo'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeState',
    //                             label: "修改可用状态",
    //                             status: false,
    //                             url: ['/host/changeState'],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeAllocation',
    //                             label: "修改分配状态",
    //                             status: false,
    //                             url: ['/host/changeAllocation'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'storageHost', label: "存储物理机列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ['/storageHost/query'], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/storageHost/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ['/storageHost/update'], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ['/storageHost/delete'], oam: true},
    //                         {
    //                             prop: 'getIbssHost',
    //                             label: "资产管理主机列表",
    //                             status: false,
    //                             url: ['/storageHost/getIbssHost'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'poolHa', label: "HA列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/poolHa/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/poolHa/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/poolHa/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/poolHa/delete"], oam: true},

    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "网络管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'ipPool', label: "IP资源池列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/ipPool/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/ipPool/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/ipPool/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: "/ipPool/delete", oam: true},
    //                         {
    //                             prop: 'updateGroup',
    //                             label: "编辑子节点",
    //                             status: false,
    //                             url: ["/ipPool/updateGroup"],
    //                             oam: true
    //                         },
    //                         {prop: 'export', label: "导出", status: false, url: ["/ipPool/export"], oam: true},
    //                         {
    //                             prop: 'poolIPList',
    //                             label: "可用IP列表",
    //                             status: false,
    //                             url: ["/ipPool/poolIPList"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改分配状态",
    //                             status: false,
    //                             url: ["/ipPool/changeAvailable"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeState',
    //                             label: "修改可用状态",
    //                             status: false,
    //                             url: ["/ipPool/changeState"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "存储管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'storageCluster', label: "存储集群管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/storageCluster/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/storageCluster/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/storageCluster/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/storageCluster/delete"], oam: true},

    //                         {
    //                             prop: 'getStorageList',
    //                             label: "获取指定存储集群的LUN列表",
    //                             status: false,
    //                             url: ["/storageCluster/getStorageList"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'getList',
    //                             label: "获取cpeh存储集群列表",
    //                             status: false,
    //                             url: ['/storageCluster/getList'],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'storage', label: "存储逻辑卷列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: "/storage/query", oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: "/storage/add", oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: "/storage/update", oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: "/storage/delete", oam: true},
    //                         {
    //                             prop: 'queryList',
    //                             label: "列表(不聚合)",
    //                             status: false,
    //                             url: "/storage/queryList",
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'getKVMStorage',
    //                             label: "获取指定资源池中底层KVM的存储信息",
    //                             status: false,
    //                             url: ["/storage/getKVMStorage"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeState',
    //                             label: "修改可用状态",
    //                             status: false,
    //                             url: ["/storage/changeState"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeAllocation',
    //                             label: "修改分配状态",
    //                             status: false,
    //                             url: ["/storage/changeAllocation"],
    //                             oam: true
    //                         },

    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "VPC管理", status: false, show: true, data: [


    //                 {
    //                     prop: 'groupDevice', label: "角色设备列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/groupDevice/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/groupDevice/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/groupDevice/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/groupDevice/delete"], oam: true},

    //                     ]
    //                 },

    //                 {
    //                     prop: 'vlanPool', label: "Vlan资源池列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/vlanPool/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/vlanPool/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/vlanPool/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/vlanPool/delete"], oam: true},
    //                     ]
    //                 },
    //                 {
    //                     prop: 'ipManage', label: "管理IP资源池列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/ipManage/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/ipManage/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/ipManage/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/ipManage/delete"], oam: true},
    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改分配状态",
    //                             status: false,
    //                             url: ["/ipManage/changeAvailable"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'slb', label: "SLB调度信息列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/slb/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/slb/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/slb/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/slb/delete"], oam: true},
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "访问控制", status: false, show: true, data: [
    //                 {
    //                     prop: 'aclGroup', label: "访问控制组列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/aclGroup/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/aclGroup/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/aclGroup/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/aclGroup/delete"], oam: true},

    //                         {
    //                             prop: 'updateIsDefaultStatus',
    //                             label: "更新是否默认访问控制组状态",
    //                             status: false,
    //                             url: ["/aclGroup/updateIsDefaultStatus"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'aclRule', label: "访问控制规则列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/aclRule/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/aclRule/add"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/aclRule/delete"], oam: true},
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "模板管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'template', label: "模板列表", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/template/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/template/add"], oam: true},
    //                         {
    //                             prop: 'queryList',
    //                             label: "列表(不聚合)",
    //                             status: false,
    //                             url: ["/template/queryList"],
    //                             oam: true
    //                         },
    //                         {prop: 'update', label: "编辑", status: false, url: ["/template/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/template/delete"], oam: true},
    //                         {prop: 'count', label: "获取记录数", status: false, url: ["/template/count"], oam: true},

    //                         {
    //                             prop: 'getListBySRUUID',
    //                             label: "多个模板列表",
    //                             status: false,
    //                             url: ["/template/getListBySRUUID"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'scanCheck',
    //                             label: "模板扫描前检查",
    //                             status: false,
    //                             url: ["/template/scanCheck"],
    //                             oam: true
    //                         },
    //                         {prop: 'scan', label: "模板扫描", status: false, url: ["/template/scan"], oam: true},
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "虚拟资源", status: false, show: true, data: [
    //                 {
    //                     prop: 'vpc', label: "VPC管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/vpc/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/vpc/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/vpc/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/vpc/delete"], oam: true},
    //                         {prop: 'count', label: "获取记录数", status: false, url: ["/vpc/count"], oam: true},

    //                     ]
    //                 },
    //                 {
    //                     prop: 'ip', label: "IP管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/ip/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/ip/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/ip/update"], oam: true},
    //                         {prop: 'destroy', label: "销毁", status: false, url: ["/ip/destroy"], oam: true},
    //                         {prop: 'count', label: "获取记录数", status: false, url: ["/ip/count"], oam: true},

    //                         {prop: 'export', label: "导出", status: false, url: ["/ip/export"], oam: true},
    //                         {prop: 'changeBind', label: "IP绑定实例", status: false, url: ["/ip/changeBind"], oam: true},
    //                         {
    //                             prop: 'changeDetach',
    //                             label: "IP解绑实例",
    //                             status: false,
    //                             url: ["/ip/changeDetach"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeBindPackage',
    //                             label: "IP绑定带宽包",
    //                             status: false,
    //                             url: ["/ip/changeBindPackage"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeDetachPackage',
    //                             label: "IP解绑带宽包",
    //                             status: false,
    //                             url: ["/ip/changeDetachPackage"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeUnblock',
    //                             label: "设置为可分配",
    //                             status: false,
    //                             url: ["/ip/changeUnblock"],
    //                             oam: true
    //                         },
    //                         {prop: 'changeBlock', label: "设置为不可分配", status: false, url: ["/ip/changeBlock"], oam: true},
    //                         {prop: 'changeHole', label: "设置为封阻", status: false, url: ["/ip/changeHole"], oam: true},
    //                         {prop: 'changeUnhole', label: "设置为解封", status: false, url: ["/ip/changeUnhole"], oam: true},
    //                         {
    //                             prop: 'changeBlockPort',
    //                             label: "设置封阻端口",
    //                             status: false,
    //                             url: ["/ip/changeBlockPort"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeUnBlockPort',
    //                             label: "设置解封端口",
    //                             status: false,
    //                             url: ["/ip/changeUnBlockPort"],
    //                             oam: true
    //                         },
    //                         {prop: 'changeState', label: "修改可用状态", status: false, url: ["/ip/changeState"], oam: true},
    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改分配状态",
    //                             status: false,
    //                             url: ["/ip/changeAvailable"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'vm', label: "虚拟机管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/vm/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/vm/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/vm/update"], oam: true},
    //                         {prop: 'delete', label: "销毁", status: false, url: ["/vm/delete"], oam: true},
    //                         {prop: 'count', label: "获取记录数", status: false, url: ["/vm/count"], oam: true},

    //                         {
    //                             prop: 'getVMConsole',
    //                             label: "获取VM的VNC链接",
    //                             status: false,
    //                             url: ["/vm/getVMConsole"],
    //                             oam: true
    //                         },
    //                         {prop: 'setCpu', label: "设置cpu", status: false, url: ["/vm/setCpu"], oam: true},
    //                         {prop: 'setRam', label: "设置内存", status: false, url: ["/vm/setRam"], oam: true},
    //                         {prop: 'setPassword', label: "设置密码", status: false, url: ["/vm/setPassword"], oam: true},
    //                         {
    //                             prop: 'updateIsDefaultStatus',
    //                             label: "更新是否默认虚拟机状态",
    //                             status: false,
    //                             url: ["/vm/updateIsDefaultStatus"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'setNetLimit',
    //                             label: "设置公私网接口速率",
    //                             status: false,
    //                             url: ["/vm/setNetLimit"],
    //                             oam: true
    //                         },
    //                         {prop: 'setIops', label: "设置磁盘IOPS", status: false, url: ["/vm/setIops"], oam: true},
    //                         {prop: 'migrate', label: "迁移VM", status: false, url: ["/vm/migrate"], oam: true},
    //                         {prop: 'export', label: "导出", status: false, url: ["/vm/export"], oam: true},
    //                         {
    //                             prop: 'changeState',
    //                             label: "设置VM电源状态",
    //                             status: false,
    //                             url: ["/vm/changeState"],
    //                             oam: true
    //                         },
    //                         {prop: 'bindCPU', label: "CPU绑定", status: false, url: ["/vm/bindCPU"], oam: true},
    //                     ]
    //                 },
    //                 {
    //                     prop: 'bandwidthPackage', label: "带宽包管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/bandwidthPackage/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/bandwidthPackage/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/bandwidthPackage/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/bandwidthPackage/delete"], oam: true},

    //                     ]
    //                 },
    //                 {
    //                     prop: 'vdi', label: "磁盘管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/vdi/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/vdi/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/vdi/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/vdi/delete"], oam: true},
    //                         {prop: 'count', label: "获取记录数", status: false, url: ["/vdi/count"], oam: true},
    //                         {prop: 'changeCopy', label: "复制磁盘", status: false, url: ["/vdi/changeCopy"], oam: true},
    //                         {prop: 'changeAttach', label: "绑定磁盘", status: false, url: ["/vdi/changeAttach"], oam: true},
    //                         {prop: 'changeDetach', label: "解绑磁盘", status: false, url: ["/vdi/changeDetach"], oam: true},
    //                         {
    //                             prop: 'getStorageList',
    //                             label: "获取指定磁盘的LUN列表",
    //                             status: false,
    //                             url: ["/vdi/getStorageList"],
    //                             oam: true
    //                         },
    //                         {prop: 'export', label: "导出", status: false, url: ["/vdi/export"], oam: true},
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: "虚拟网络", status: false, show: true, data: [
    //                 {
    //                     prop: 'vswitch', label: "交换机管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/vswitch/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/vswitch/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/vswitch/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/vswitch/delete"], oam: true},

    //                         {
    //                             prop: 'getVMCode',
    //                             label: "获取VMCode",
    //                             status: false,
    //                             url: ["/vswitch/getVMCode"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'routes', label: "路由表管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/routes/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/routes/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/routes/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/routes/delete"], oam: true},
    //                     ]
    //                 },
    //                 {
    //                     prop: 'nat', label: "NAT管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/nat/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/nat/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/nat/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/nat/delete"], oam: true},

    //                         {prop: 'getPriveIP', label: "获取内网IP", status: false, url: ["/nat/getPriveIP"], oam: true},
    //                         {prop: 'getPublicIP', label: "获取公网IP", status: false, url: ["/nat/getPublicIP"], oam: true},
    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改启用状态",
    //                             status: false,
    //                             url: ["/nat/changeAvailable"],
    //                             oam: true
    //                         },
    //                         {prop: 'changeState', label: "修改可用状态", status: false, url: ["/nat/changeState"], oam: true},
    //                     ]
    //                 },

    //                 {
    //                     prop: 'snat', label: "SNAT管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/snat/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ["/snat/add"], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/snat/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/snat/delete"], oam: true},

    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改启用状态",
    //                             status: false,
    //                             url: ["/snat/changeAvailable"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeState',
    //                             label: "修改可用状态",
    //                             status: false,
    //                             url: ["/snat/changeState"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },


    //                 {
    //                     prop: 'dnat', label: "DNAT管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: ["/dnat/query"], oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: ['/dnat/add'], oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: ["/dnat/update"], oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: ["/dnat/delete"], oam: true},

    //                         {
    //                             prop: 'changeAvailable',
    //                             label: "修改启用状态",
    //                             status: false,
    //                             url: ["/dnat/changeAvailable"],
    //                             oam: true
    //                         },
    //                         {
    //                             prop: 'changeState',
    //                             label: "修改可用状态",
    //                             status: false,
    //                             url: ["/dnat/changeState"],
    //                             oam: true
    //                         },
    //                     ]
    //                 },
    //                 {
    //                     prop: 'slbs', label: "SLB管理", status: false, data: [
    //                         {prop: 'list', label: "列表", status: false, url: "/slbs/query", oam: true},
    //                         {prop: 'add', label: "添加", status: false, url: "/slbs/add", oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: "/slbs/update", oam: true},
    //                         {prop: 'delete', label: "删除", status: false, url: "/slbs/delete", oam: true},
    //                     ]
    //                 },
    //             ]
    //         },
    //         // {
    //         //     label: "RDS管理", status: false, show: true, data: [
    //         //         {
    //         //             label: "RDS实例列表", status: false, data: [
    //         //                 {label: "列表", status: false, url: [], oam: true},
    //         //                 {label: "启动", status: false, url: [], oam: true},
    //         //                 {label: "停止", status: false, url: [], oam: true},
    //         //                 {label: "重启", status: false, url: [], oam: true},
    //         //             ]
    //         //         },
    //         //         {
    //         //             label: "RDS日志", status: false, data: [
    //         //                 {label: "控制中心日志", status: false, url: [], oam: true},
    //         //                 {label: "agnent日志", status: false, url: [], oam: true},
    //         //                 {label: "Mysql切换主从日志", status: false, url: [], oam: true},
    //         //                 {label: "Mysql切换MGR日志", status: false, url: [], oam: true},
    //         //                 {label: "上报告警日志", status: false, url: [], oam: true},
    //         //                 {label: "中心服务器上报日志", status: false, url: [], oam: true},
    //         //                 {label: "任务信息", status: false, url: [], oam: true},
    //         //             ]
    //         //         },
    //         //         {
    //         //             label: "RDS监控配置", status: false, data: [
    //         //                 {label: "列表", status: false, url: [], oam: true},
    //         //                 {label: "添加", status: false, url: [], oam: true},
    //         //                 {label: "编辑", status: false, url: [], oam: true},
    //         //                 {label: "删除", status: false, url: [], oam: true},
    //         //             ]
    //         //         },
    //         //         {
    //         //             label: "通用配置", status: false, data: [
    //         //                 {label: "列表", status: false, url: [], oam: true},
    //         //                 {label: "添加", status: false, url: [], oam: true},
    //         //                 {label: "编辑", status: false, url: [], oam: true},
    //         //                 {label: "删除", status: false, url: [], oam: true},
    //         //             ]
    //         //         },
    //         //         {
    //         //             label: "版本管理", status: false, data: [
    //         //                 {label: "列表", status: false, url: [], oam: true},
    //         //                 {label: "添加", status: false, url: [], oam: true},
    //         //                 {label: "编辑", status: false, url: [], oam: true},
    //         //                 {label: "删除", status: false, url: [], oam: true},
    //         //             ]
    //         //         },
    //         //         {
    //         //             label: "版本设置", status: false, data: [
    //         //                 {label: "列表", status: false, url: [], oam: true},
    //         //                 {label: "添加", status: false, url: [], oam: true},
    //         //                 {label: "编辑", status: false, url: [], oam: true},
    //         //                 {label: "删除", status: false, url: [], oam: true},
    //         //             ]
    //         //         },
    //         //         {label: "缓存管理", status: false, url: [], oam: true},
    //         //     ]
    //         // },


    //         {
    //             label: "系统管理", status: false, show: true, data: [
    //                 {
    //                     prop: 'oamLog', label: "操作日志", status: false, show: true, data: [
    //                         {prop: 'list', label: "列表", status: false, url: "/oamLog/query", oam: true},

    //                     ]
    //                 },
    //                 {
    //                     prop: 'task', label: "任务列表", status: false, show: true, data: [
    //                         {prop: 'list', label: "列表", status: false, url: "/task/query", oam: true},

    //                     ]
    //                 },
    //                 {
    //                     prop: 'config', label: "配置管理", status: false, show: true, data: [
    //                         {prop: 'list', label: "列表", status: false, url: "/config/query", oam: true},
    //                         {prop: 'update', label: "编辑", status: false, url: "/config/update", oam: true},

    //                     ]
    //                 },

    //             ]
    //         },
    //     ]
    // },
    businessManagement: {
        label: "平台管理模块", data: [
            {
                prop: "platform", label: "平台设置", status: false, show: true, data: [
                    {
                        prop: "platformOver", label: "平台概览", status: false, data: [
                            {
                                prop: "accessPlatform",
                                label: "访问平台",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo'],
                                oam: false
                            },
                            {
                                prop: "setSystemInfo",
                                label: "设置系统信息",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo'],
                                oam: false
                            },
                            {
                                prop: "setproductDiscount",
                                label: "设置产品定价",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo'],
                                oam: false
                            },
                            {
                                prop: "setPay",
                                label: "设置支付",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo'],
                                oam: false
                            },
                            {
                                prop: "setEmail",
                                label: "设置邮箱",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: "configSystem", label: "系统设置", status: false, data: [
                            {
                                prop: "configSystemInfo",
                                label: "系统信息设置",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo', '/user/agentConfig/updateSystemInfo'],
                                oam: false
                            },
                            {
                                prop: "configEmail",
                                label: "邮箱配置",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo', '/user/agentConfig/setUserEmailConfig'],
                                oam: false
                            },
                            {
                                prop: "configPay",
                                label: "支付设置",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo'],
                                oam: false
                            },
                            {
                                prop: "configStatsCode",
                                label: "统计代码设置",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo', '/user/agentConfig/setTplStatsCodeHeader', '/user/agentConfig/setTplStatsCodeFooter'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: "funcConfig", label: "功能配置", status: false, data: [
                            {
                                prop: "resourceFunc",
                                label: "资源功能配置",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo', '/user/agentConfig/setResourceFunction'],
                                oam: false
                            },
                            // {
                            //     prop: "priceSetting",
                            //     label: "计价配置",
                            //     status: false,
                            //     url: ['/user/agentConfig/setBillingSwitch'],
                            //     oam: false
                            // },
                            {
                                prop: "finance",
                                label: "用户中心模块配置",
                                status: false,
                                url: ['/user/agentConfig/getSystemInfo', '/user/agentConfig/setResourceFunction'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: "pricing", label: "产品定价", status: false, data: [
                            {
                                prop: "productDiscount",
                                label: "定价设置",
                                status: false,
                                // url: ['/system/config/getProductDiscount', '/system/config/setProductDiscount'],
                                url: ['/user/agentConfig/getSystemInfo', '/user/agentConfig/setUserResourceVipRate'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: "pageSet", label: "页面设置", status: false, data: [
                            {
                                prop: "setTplStyle",
                                label: "皮肤风格设置",
                                status: false,
                                url: ['/user/agentConfig/setTplStyle'],
                                oam: false
                            },
                            {
                                prop: "setTplImage",
                                label: "首页大图设置",
                                status: false,
                                url: ['/user/agentConfig/getTplImage', '/user/agentConfig/setTplImageSort', '/user/agentConfig/deleteTplImage'],
                                oam: false
                            },
                        ]
                    },
                    {
                        prop: "bulletin", label: "公告管理", status: false, data: [
                            {prop: 'create', label: "新建公告", status: false, url: ['/user/bulletin/add'], oam: false},
                            {prop: 'update', label: "修改公告", status: false, url: ['/user/bulletin/update'], oam: false},
                            {prop: 'delete', label: "删除", status: false, url: ['/user/bulletin/delete'], oam: false},
                            {prop: 'list', label: "列表", status: false, url: ['/user/bulletin/query'], oam: false},
                        ]
                    },
                ]
            },
        ]
    }
}
let module: any = {
    systemSetup: 1,
    operationsManagement: 2,
    resourceManagement: 3,
    businessManagement: 4,
}

// @ts-ignore
initPermission();

function initPermission() {
    for (let i in permission) {
        permission[i]['index'] = 0
        initLabel(permission[i].data, 1)
    }
}

function initLabel(data: any, index: any, id: any = '') {
    for (let i in data) {
        data[i].status = data[i].disabled ? data[i].status : false;
        data[i].id = id
        if (index >= 2) {
            data[i].id += data[i].id === '' ? data[i].prop : '-' + data[i].prop;
        }
        let newIndex = index + 1;
        if (data[i].data) {
            initLabel(data[i].data, newIndex, data[i].id)
        }
    }
}


export default {
    permission,
    initPermission,
}
